import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const GET_USERS_SUBSCRIPTION: UrlConstant = { path: '/users/subscription', method: HttpMethod.GET };
